// removed by extract-text-webpack-plugin
module.exports = {"Item":"navItem__Item__1_Wnm","Link":"navItem__Link__3fcr2","ActiveLink":"navItem__ActiveLink__87yVC navItem__Item__1_Wnm","Ntf":"navItem__Ntf__l9Abj"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Navigation/NavItem/navItem.css
// module id = 891
// module chunks = 2